import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  api = environment.apiUrl;
  options:any;

  constructor(private http: HttpClient) { }

  getRunReport(runId: number) {
    this.options = { responseType: "text" };
    return this.http.get<any>(this.api + 'run/Report?runid=' + runId, this.options)
    .toPromise()
    .then(res => <any>res)
    .then(data => { return data; });
  }

  getSampleReport(sampleId: number) {
    this.options = { responseType: "text" };
    return this.http.get<any>(this.api + 'sample/Report?sampleId=' + sampleId, this.options)
    .toPromise()
    .then(res => <any>res)
    .then(data => { return data; });
  }

  getRunList() {
    return this.http.get<any>(this.api + 'run/List')
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  getSampleList(runId: number) {
    return this.http.get<any>(this.api + 'sample/List?runid=' + runId)
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  getRunDetail(runId: number) {
    return this.http.get<any>(this.api + 'run/Detail?runid=' + runId)
    .toPromise()
    .then(res => <any>res)
    .then(data => { return data; });
  }

  getSampleDetail(sampleId: number) {
    return this.http.get<any>(this.api + 'sample/Detail?sampleId=' + sampleId)
    .toPromise()
    .then(res => <any>res)
    .then(data => { return data; });
  }

  approveSample(sampleId: number) {
    return this.http.post<any>(this.api + "sample/Approve", JSON.stringify(sampleId))
    .toPromise()
    .then(response => {
        return response as any;
    });
  }

  retestSample(runId: number) {
    return this.http.post<any>(this.api + "sample/Retest", JSON.stringify(runId))
    .toPromise()
    .then(response => {
        return response as any;
    });
  }

  approveRun(runId: number) {
    return this.http.post<any>(this.api + "run/Approve", JSON.stringify(runId))
    .toPromise()
    .then(response => {
        return response as any;
    });
  }

  retestRun(runId: number) {
    return this.http.post<any>(this.api + "run/Retest", JSON.stringify(runId))
    .toPromise()
    .then(response => {
        return response as any;
    });
  }

  sendSampleToOC(sampleId: number) {
    return this.http.post<any>(this.api + "sample/sendToOC", JSON.stringify(sampleId))
    .toPromise()
    .then(response => {
        return response as any;
    });
  }

  sendRunToStorage(runId: number) {
    return this.http.post<any>(this.api + "run/sendToStorage", JSON.stringify(runId))
    .toPromise()
    .then(response => {
        return response as any;
    });
  }

  importRuns(){
    return this.http.get<any>(this.api + 'run/import')
    .toPromise()
    .then(res => <any>res)
    .then(data => { return data; });
  }

  getPendingRetestList(){
    return this.http.get<any>(this.api + 'sample/PendingRetests')
    .toPromise()
    .then(res => <any>res)
    .then(data => { return data; });
  }

  sendCompleteEmail(runId: number){
    return this.http.post<any>(this.api + "run/sendCompleteEmail", JSON.stringify(runId))
    .toPromise()
    .then(response => {
        return response as any;
    });
  }
}
